import { List, Map } from 'immutable';

export default Map({
  sidebarIsVisible: false,
  modalIsVisible: false,
  notifications: Map({
    loading: false,
    loadingMore: false,
    error: null,
    unreadCount: 0,
    hasNextPage: false,
    data: List(),
  }),
  queue: List(),
  modal: Map({
    title: '',
    content: '',
  }),
});
